import axios from "axios";

const apiLogros = {
	async readLogrosAcad(idUser) {           
		const response = await axios.get("/api/logrosacad/"+idUser);  //LEER
		return response.data;        
	},
	async createLogrosAcad(requestData) {
		const response = await axios.post("/api/logrosacad", requestData); //INSERTAR
		return response.data;
	},
	async updateLogrosAcad(idLogro, requestData) {
		const response = await axios.put("/api/logrosacad/"+idLogro, requestData); //UPDATE
		return response.data;
	},
	async deleteLogrosAcad(idLogro) {
		const response = await axios.delete("/api/logrosacad/"+idLogro); //ELIMINAR
		return response.data;
	}
};

export default apiLogros;
